import { render, staticRenderFns } from "./BandeiraVisa.vue?vue&type=template&id=43a77aa5&"
import script from "./BandeiraVisa.vue?vue&type=script&lang=js&"
export * from "./BandeiraVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports